import React, { FC } from "react";
import { Loader } from "@portal/components";

export const OidcAuthenticating: FC = () => {
  return <Loader />;
};
